/**
 * Comparaison de texte telle qu'un agent l'attend : sans accents, sans casse.
 *
 * POURQUOI. Un rédacteur a cherché « MENAGE » et n'a rien trouvé, alors que la base
 * contient « Ménagère ». Le filtre d'Ant Design ignore la casse mais pas les
 * accents : « e » et « è » y sont deux caractères sans rapport. Sur un clavier de
 * bureau, taper les accents ralentit, et personne ne devrait avoir à deviner
 * l'orthographe exacte d'une entrée pour la retrouver.
 *
 * Les espaces sont conservés : « Kossi Mensah » reste deux mots, et les réduire
 * ferait correspondre des chaînes qui n'ont rien à voir.
 */
export const sansAccents = (valeur) =>
  String(valeur ?? '')
    .normalize('NFD')
    // Bloc « Combining Diacritical Marks » : ce que NFD a détaché des lettres.
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

/**
 * Filtre d'un `Select` d'Ant Design, insensible aux accents.
 *
 * Cherche dans le libellé, la valeur ET le contenu de l'option : toutes les listes
 * ne sont pas construites de la même façon. Celles qui reçoivent `options` portent
 * un `label` ; celles qui déclarent des `<Option>` portent leur texte dans
 * `children`. Ne regarder que le premier ferait taire la recherche des secondes -
 * plus grave que le défaut qu'on corrige, car elle fonctionne aujourd'hui.
 *
 * À passer tel quel : `filterOption={filtreSansAccents}`.
 */
export const filtreSansAccents = (saisie, option) => {
  const terme = sansAccents(saisie);
  if (!terme) return true;

  const textes = [option?.label, option?.value, option?.children]
    .filter((v) => typeof v === 'string' || typeof v === 'number');

  return textes.some((v) => sansAccents(v).includes(terme));
};
